module.exports = __webpack_public_path__ + "img/alimentacion.d5a66705.jpg";